import { getColumnFieldType } from './filters/filterOperators'

const aTagRegex = /(<[a|A][^>]*>)/
const aTagEndRegex = /(<\/[a]>)/

const isAnchorColumn = (exampleRow, col, data) => {
    const rows = Array.isArray(data) ? data : []
    for (let i = 0; i < rows.length; i++) {
        const value = rows[i] ? rows[i][col] : null
        if (value != null && value !== '') {
            return typeof value === 'string' && value.startsWith('<a')
        }
    }
    const fallback = exampleRow ? exampleRow[col] : null
    return typeof fallback === 'string' && fallback.startsWith('<a')
}

const DefaultSortTypeFunction = (exampleRow, col, data) =>
    isAnchorColumn(exampleRow, col, data)
        ? (rowA, rowB, columnId, desc) => {
              try {
                  const valueA = rowA.values[columnId]
                  const valueB = rowB.values[columnId]
                  const contentA = valueA
                      .replace(aTagRegex, '')
                      .replace(aTagEndRegex, '')
                  const contentB = valueB
                      .replace(aTagRegex, '')
                      .replace(aTagEndRegex, '')
                  return contentA.toLowerCase() < contentB.toLowerCase()
                      ? -1
                      : 1
              } catch {
                  return -1
              }
          }
        : ['number', 'bit'].includes(getColumnFieldType(col, data))
        ? 'basic'
        : 'alphanumeric'

const customSortStationCode = (rowA, rowB, columnId) => {
    const getSortValue = (value) => {
        if (!value) return { length: 0, numericPart: '' }

        const stringValue = value.toString()

        // Find the position of the first digit (PATINDEX('%[0-9]%', f.AgencyFacilityCode))
        const firstDigitIndex = stringValue.search(/\d/)

        if (firstDigitIndex === -1) {
            // No digits found
            return { length: 0, numericPart: '' }
        }

        // Extract the numeric part starting from first digit (SUBSTRING(f.AgencyFacilityCode, PATINDEX...))
        const numericPart = stringValue.substring(firstDigitIndex)

        // Get length of numeric part (LEN(SUBSTRING(...)))
        const length = numericPart.length

        // Return sortable value: length + ', ' + numericPart
        return {
            length,
            numericPart,
            sortString: `${length
                .toString()
                .padStart(10, '0')}, ${numericPart.padStart(20, '0')}`,
        }
    }

    const sortValueA = getSortValue(rowA.values[columnId])
    const sortValueB = getSortValue(rowB.values[columnId])

    // Compare by length first, then by numeric part
    if (sortValueA.length !== sortValueB.length) {
        return sortValueA.length - sortValueB.length
    }

    // If lengths are equal, compare the numeric parts
    return sortValueA.numericPart.localeCompare(
        sortValueB.numericPart,
        undefined,
        { numeric: true }
    )
}

export { customSortStationCode }
export default DefaultSortTypeFunction
